import { SectionLabel } from "../SectionLabel";

const features = [
  "Build your own branded business profile",
  "Grow a list of loyal followers who get notified",
  "Send push notifications directly to your followers",
  "Track engagement and see who loves your brand",
];

const CheckIcon = () => (
  <span className="flex-shrink-0 flex items-center justify-center w-[22px] h-[22px] lg:w-[24px] lg:h-[24px] rounded-full bg-[#D90000]">
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <path d="M2.5 6.2 4.9 8.5 9.5 3.8" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </span>
);

export const BusinessProfileSection = () => {
  return (
    <section className="w-full px-[16px] sm:px-6 lg:px-[80px] pt-16 lg:pt-[88px]">
      <div className="relative mx-auto w-full max-w-[1620px] overflow-hidden rounded-[28px] lg:rounded-[48px] bg-[linear-gradient(100deg,#FFFFFF_20%,#FFF9E6_60%,#FFF2C4_100%)]">
        <div className="grid grid-cols-1 lg:grid-cols-2 items-center">
          {/* LEFT */}
          <div className="px-6 sm:px-10 lg:pl-[53px] lg:pr-0 pt-10 lg:pt-[56px] pb-[16px] lg:pb-[80px]">
            <SectionLabel align="left">Business Profile</SectionLabel>

            <h2 className="mt-6 lg:mt-8 text-[#171717] font-normal leading-[1.2] tracking-[-1.5px] text-[32px] sm:text-[44px] lg:text-[64px]">
              Build a Loyal Following.
              <br />
              Keep Them <span className="text-[#C80000] font-medium">Coming Back.</span>
            </h2>

            <p className="mt-6 max-w-[580px] text-[#2A2A2A] text-[15px] lg:text-[20px] leading-[1.4]">
              Turn one-time deal seekers into loyal regulars. Your offers appear at the top of your followers' feeds for
              maximum visibility, and send targeted push notifications to drive immediate foot traffic.
            </p>

            <ul className="mt-8 lg:mt-[70px] space-y-4 lg:space-y-6">
              {features.map((feature) => (
                <li key={feature} className="flex items-center gap-[16px] text-[#222] text-[15px] lg:text-[18px] 2xl:text-[22px]">
                  <CheckIcon />
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          {/* RIGHT */}
          <div className="relative flex justify-center lg:justify-end lg:pl-[40px] xl:pr-[clamp(40px,calc(100vw-1300px),140px)] min-[1700px]:pr-[200px] pt-6 lg:pt-[60px] h-[420px] sm:h-[520px] lg:h-full">
            {/* Phone + notification share one anchor so the card always overlaps the phone, never the text column. */}
            <div className="relative h-full">
              <div className="h-full overflow-hidden">
                <img
                  src="/images/Webp/Mobile4.webp"
                  alt="Business profile in the My Couponbook app"
                  className="w-[260px] sm:w-[320px] lg:w-[340px] xl:w-[400px] 2xl:w-[484px] object-cover object-top [-webkit-mask-image:linear-gradient(180deg,#000_55%,transparent_100%)] [mask-image:linear-gradient(180deg,#000_55%,transparent_100%)]"
                />
              </div>

              <div className="absolute z-10 left-1/2 -translate-x-1/2 lg:translate-x-0 lg:left-auto lg:right-[18%] xl:right-[26%] 2xl:right-[32%] min-[1700px]:right-[45%] top-[38%] lg:top-[40%] flex items-center gap-[16px] rounded-[20px] lg:rounded-[28px] border-[2px] border-white bg-white/75 backdrop-blur-md shadow-[0_20px_50px_rgba(0,0,0,0.12)] p-2.5 lg:p-3 pr-6 lg:pr-8 2xl:pr-12 w-max">
                <img src="/images/Alert.svg" alt="" className="w-[56px] h-[56px] lg:w-[72px] lg:h-[72px] 2xl:w-[98px] 2xl:h-[98px]" />
                <div>
                  <div className="text-[#171717] text-[15px] lg:text-[18px] 2xl:text-[22px]">New deal from Bercelle!</div>
                  <div className="mt-[4px] text-[#333] text-[12px] lg:text-[14px] 2xl:text-[16px]">Sent to 2.4K followers</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
